import { Component, OnInit, inject } from '@angular/core';
import { AnalyticsService } from '@app/core/services/analytics.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.scss'],
    imports: [TranslateModule],
    standalone: true
})
export class AboutComponent implements OnInit {
  readonly translate = inject(TranslateService);
  private readonly analyticsService = inject(AnalyticsService);


  ngOnInit(): void {
    this.analyticsService.setDocumentTitleWithExhibitionTitle('About');
  }

}
